(function () {

  angular
    .module("pcmCommon")
    .factory("stopService", stopService);

  stopService.$inject = [];

  function stopService() {

    var service = {
      getHoursFromString: getHoursFromString,
      getSecondsFromString: getSecondsFromString,
      getDurationInHHMM: getDurationInHHMM,
    };

    return service;

    /////////////////////

    //Given a string, get hours from format of either hh:mm, hh.hh or mm.
    //If not in any of these formats, returns null.
    function getHoursFromString(str) {
      if (!str) {
        return 0;
      } //Blank string should be valid (since the field is optional)

      //hh:mm
      var pieces = str.split(":");
      if (pieces.length === 2 && /^[0-9]{1,}:[0-9]{2}$/.exec(str) !== null) {
        //Regex matches <one or more digits>:<exactly two digits>
        return Number(pieces[0]) + Number(pieces[1]) / 60;
      }
      //hh.hh
      pieces = str.split(".");
      if (pieces.length === 2 && /^([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/.exec(str) !== null) {
        //Regex matches <any number of digits>.<any number of digits>
        return Number(str);
      }
      //mm
      if (/^[0-9]+$/.exec(str) !== null) {
        //Regex matches any sequence of digits
        let fieldNum = Number(str);
        if (fieldNum < 0) {
          return null;
        }
        return Number(str) / 60;
      }
      return null;
    }

    //Same as above function but returns seconds, not hours
    function getSecondsFromString(str) {
      var hours = getHoursFromString(str);
      if (!hours) {
        return 0;
      }
      return hours * 3600;
    }

    //Always returns in hh:mm format from a string that is either in hh:mm, hh.hh or mm
    function getDurationInHHMM(str) {
      var hours = getHoursFromString(str);
      if (!hours) {
        return "00:00";
      }
      var decimal = hours - Math.floor(hours);
      var minutes = String(Math.round(decimal * 60));
      hours = String(Math.floor(hours));

      if (hours.length === 1) {
        hours = "0" + hours;
      }
      if (minutes.length === 1) {
        minutes = "0" + minutes;
      }
      if (minutes.length > 2) {
        minutes = minutes[0] + minutes[1];
      }
      return hours + ":" + minutes;
    }

  }
})();



// WEBPACK FOOTER //
// ./app/pcm-common/stop.service.js